import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import { Button } from 'components';
import { POUCHERS_APP_URL } from 'constants';
import { ReactComponent as AppStore } from 'assets/svg/app-store-icon.svg';
import { ReactComponent as PlayStore } from 'assets/svg/play-store-icon.svg';

export default function Hero({ title, description, image, buttonName, subTitle, height }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.5 });

  const variants = {
    visible: { x: '0px', opacity: 1, transition: { type: 'spring', duration: 5 } },
    hidden: { x: '100px', opacity: 0 }
  };

  const variantTitle = {
    visible: { y: '0px', opacity: 1, transition: { type: 'tween', duration: 2 } },
    hidden: { y: '20px', opacity: 0 }
  };

  return (
    <div
      className={`container flex flex-col lg:flex-row pt-[120px] sm:pt-[190px] ${
        height || 'lg:h-[750px] min-h-[750px]'
      }`}
      ref={ref}>
      <div className="max-w-[800px] lg:max-w-[626px] mx-auto lg:mr-[59px] mt-[30px] sm:mt-0 sm:text-center lg:text-left mb-[60px] lg:mb-0">
        <p className="text-purple text-16 font-dmsans_b mb-[12px]">{subTitle}</p>
        <motion.h1
          variants={variantTitle}
          animate={inView ? 'visible' : 'hidden'}
          initial="hidden"
          className="text-dark text-36 sm:text-48 font-altone_b leading-[44px] sm:leading-[60px] mb-[24px]">
          {title}
        </motion.h1>
        <p className="text-18 sm:text-20 text-[#667085] font-dmsans_r leading-[28px] sm:leading-[30px] mb-[24px]">
          {description}
        </p>
        <Button className="bg-purple text-white font-inter_medium whitespace-nowrap mb-[12px]">
          <a
            href={`${POUCHERS_APP_URL}/create-account`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center">
            <p className="mr-[16px]">{buttonName}</p>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.75 11.7246L4.75 11.7246"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.7012 5.701L19.7512 11.725L13.7012 17.75"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </Button>
        <div className="w-full flex justify-start sm:justify-center md:justify-start">
          <div className="flex items-center justify-between gap-1 w-[150px]">
            <p className="text-[14px] font-inter_semiBold text-purple">Available on</p>
            <Link to={`${process.env.REACT_APP_POUCHERS_APP_IOS}`} target="_blank">
              <AppStore className="cursor-pointer" />
            </Link>
            <Link to={`${process.env.REACT_APP_POUCHERS_APP_ANDROID}`} target="_blank">
              <PlayStore className="cursor-pointer" />
            </Link>
          </div>
        </div>
      </div>
      <motion.div
        variants={variants}
        animate={inView ? 'visible' : 'hidden'}
        initial="hidden"
        className="flex flex-col items-center justify-end h-full w-full">
        {image}
      </motion.div>
    </div>
  );
}
